import { Typography, Button } from '@material-ui/core';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
export default function TenureForm(props: any) {
  const { amountInput, setReturnValue, returnData, onClickMonth } = props;
  return (
    <>
      <Box className='cardHeadingNew'>
        <Typography variant='h1'>Choose your tenure</Typography>
      </Box>

      <Box className='tenureAmountGrid'>
        <Grid container spacing={0} alignItems='center'>
          <Grid item xs={8}>
            <Typography>Investment amount</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography align='right'>
              <strong>
                {/* <span>₹</span> */}
                {amountInput}
              </strong>
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={0} alignItems='center'>
          <Grid item xs={8}>
            <Typography>Expected returns</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography align='right'>
              <strong>
                {/* <span>₹</span> */}
                {setReturnValue?.expectedReturns}%{" "}{setReturnValue?.message}
              </strong>
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box className='holdingPeriods'>
        <Typography variant='h6'>Holding period</Typography>
        <Box className='monthsButtons'>
          {returnData.map((dataKey: any) => (
            <Button
              className={dataKey.isSelected ? 'active' : ''}
              onClick={() => onClickMonth(dataKey.id)}
            >
              {/* {dataKey.id} Month */}

              <Typography>{dataKey.id} months </Typography>
              <Typography align='right'>
                <img src={dataKey.tenureImg} alt='' />
              </Typography>
            </Button>
          ))}
        </Box>
      </Box>
    </>
  );
}
